import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ByocEpisodeFetchService } from '../service/fetch.service';
import { group } from '../../../../utils';

@Component({
    selector: 'app-byoc-episode-step-fetch-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
    standalone: false
})
export class ByocEpisodeStepGeneralQuestionsComponent implements OnInit, OnDestroy {
    @Input()
    formArray!: UntypedFormArray;

    creating = false;

    readonly group = group;

    private subscriptions = new Subscription();

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private byocEpisodeFetchService: ByocEpisodeFetchService,
    ) {}

    ngOnInit() {
        this.creating = false;
        this.subscriptions.add(
            this.byocEpisodeFetchService.closeEvent.subscribe(() => {
                this.changeDetectorRef.detectChanges();
                this.creating = false;
                this.byocEpisodeFetchService.updatePs();
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Count of question
     */
    get count(): number {
        return this.formArray.value.length;
    }

    /**
     * Editing flag
     */
    get editing(): boolean {
        return this.byocEpisodeFetchService.editing;
    }

    /**
     * Editing Index
     */
    get editingIndex(): number {
        return this.byocEpisodeFetchService.editingIndex;
    }

    /**
     * Create Click
     */
    createClick(): void {
        this.byocEpisodeFetchService.editing = true;
        this.creating = true;
        this.byocEpisodeFetchService.updatePsScrollBottom();
    }
}
